import { CartAddEvent } from '@theme/events';

/**
 * Adds one unit of an approved add-on to the cart, then lets the theme's own
 * cart:update pipeline re-render the drawer / cart page (bar, totals, add-ons).
 */
class DsCartAddon extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.error = this.querySelector('.ds-addons__error');
    this.button?.addEventListener('click', this.add);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.add);
  }

  add = async () => {
    const variantId = Number(this.dataset.variantId);
    if (!variantId || !this.button || this.button.disabled) return;

    this.button.disabled = true;
    this.button.setAttribute('aria-busy', 'true');
    this.error?.classList.add('hidden');

    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el instanceof HTMLElement && el.dataset.sectionId)
      .filter(Boolean);
    const root = window.Shopify?.routes?.root ?? '/';

    try {
      const addResponse = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      });
      const added = await addResponse.json();
      if (!addResponse.ok || added.status) throw new Error(added.description || 'Add to cart failed');

      const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();

      document.dispatchEvent(
        new CartAddEvent(cart, 'ds-cart-addon', {
          source: 'ds-cart-addon',
          itemCount: cart.item_count,
          variantId: String(variantId),
          sections: added.sections,
        })
      );
    } catch (error) {
      console.error(error);
      this.error?.classList.remove('hidden');
      this.button.disabled = false;
      this.button.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('ds-cart-addon')) {
  customElements.define('ds-cart-addon', DsCartAddon);
}
